import { render } from "./Settings.vue?vue&type=template&id=41cad7a8"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=41cad7a8&lang=css"
script.render = render

export default script